'use client';

import React, { createContext, PropsWithChildren, useContext, useState } from 'react';
import { YourPriceResponseWithCurrency } from '@/src/lib/your-price/types';

export type YourPriceContextType = {
  updateYourPriceData: ({
    isLoading,
    yourPrice,
    error,
  }: {
    isLoading: boolean;
    yourPrice: YourPriceResponseWithCurrency | undefined;
    error: Error | null;
  }) => void;
  yourPrice: YourPriceResponseWithCurrency | undefined;
  isLoading: boolean;
  error: Error | null;
};

export const YourPriceContext = createContext<YourPriceContextType>({
  updateYourPriceData: () => {},
  yourPrice: undefined,
  isLoading: false,
  error: null,
});
export const useYourPriceContext = () => useContext(YourPriceContext);

export default function YourPriceProvider({ children, loading = false }: PropsWithChildren<{ loading?: boolean }>) {
  const [yourPrice, setYourPrice] = useState<YourPriceResponseWithCurrency | undefined>();
  const [isLoading, setIsLoading] = useState(loading);
  const [error, setError] = useState<Error | null>(null);

  function updateYourPriceData({
    isLoading,
    yourPrice,
    error,
  }: {
    isLoading: boolean;
    yourPrice: YourPriceResponseWithCurrency | undefined;
    error: Error | null;
  }) {
    setIsLoading(isLoading);
    setYourPrice(yourPrice);
    setError(error);
  }

  return (
    <YourPriceContext.Provider value={{ updateYourPriceData, yourPrice, isLoading, error }}>
      {children}
    </YourPriceContext.Provider>
  );
}
